import { NavLink } from 'react-router-dom';
import { publicUrlFor } from '../../../globals/constants';
import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import { data } from '../../../globals/data/global-services';

export default function Footer1() {
	const currentpath = useLocation().pathname;

	const displayNewsSubscription = useMemo(
		() =>
			currentpath !== '/' && !currentpath.includes('/services/global-services'),
		[currentpath],
	);

	console.log(data, 'footer1.jsx line 16');

	return (
		<>
			<footer className='footer-dark'>
				{/* NEWS LETTER SECTION START */}
				{displayNewsSubscription && (
					<div className='ftr-nw-ltr site-bg-white'>
						<div className='ftr-nw-ltr-inner site-bg-primary'>
							<div className='container'>
								<div className='ftr-nw-img'>
									<img
										src={publicUrlFor('/assets/images/news-l-bg.png')}
										alt='#'
									/>
								</div>
								<div className='ftr-nw-content'>
									<div className='ftr-nw-title'>
										Subscribe for offers and news
									</div>
									<div className='ftr-nw-form'>
										<form>
											<input
												name='news-letter'
												className='form-control'
												placeholder='Enter Your Email'
												type='text'
											/>
											<button className='ftr-nw-subcribe-btn'>
												Subscribe Now
											</button>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
				)}
				{/* NEWS LETTER SECTION END */}

				<div
					className='ftr-bg'
					style={{
						backgroundImage: `url(${publicUrlFor('/assets/images/f-bg.jpg')})`,
					}}
				>
					{/* FOOTER BLOCKES START */}
					<div className='footer-top'>
						<div className='container'>
							<div className='row'>
								<div className='col-lg-3 col-md-6'>
									<div className='widget widget_about'>
										<div className='logo-footer clearfix'>
											<NavLink to='/index'>
												<img
													src={publicUrlFor('/assets/images/logo-dark.png')}
													alt='#'
												/>
											</NavLink>
										</div>
										<p>
											{/* 2 line description for secure logistics company like brinksglobal.com */}
											Velocent Global is a leader in secure logistics solutions,
											providing tailored services to meet the unique needs of
											our clients.
										</p>
										{/* <ul className='social-icons'>
											<li>
												<a
													href='https://www.facebook.com/'
													className='fa fa-facebook'
												>
													{' '}
												</a>
											</li>
											<li>
												<a
													href='https://www.twitter.com/'
													className='fa fa-twitter'
												>
													{' '}
												</a>
											</li>
											<li>
												<a
													href='https://www.instagram.com/'
													className='fa fa-instagram'
												>
													{' '}
												</a>
											</li>
											<li>
												<a
													href='https://www.youtube.com/'
													className='fa fa-youtube-play'
												>
													{' '}
												</a>
											</li>
										</ul> */}
									</div>
								</div>

								<div className='col-lg-3 col-md-6'>
									<div className='widget widget_services ftr-list-center'>
										<h3 className='widget-title'>Quick Links</h3>
										<ul>
											<li>
												<NavLink to='/about-us'>About</NavLink>
											</li>
											<li>
												<NavLink to='/services/global-services'>
													Global Services
												</NavLink>
											</li>

											<li>
												<NavLink to='/contact-us'>Contact Us</NavLink>
											</li>
										</ul>
									</div>
								</div>

								<div className='col-lg-3 col-md-6'>
									<div className='widget widget_services ftr-list-center'>
										<h3 className='widget-title'>Services</h3>
										<ul>
											{data?.services?.services?.map((s) => (
												<li>
													<NavLink to={s?.path}>{s?.title}</NavLink>
												</li>
											))}
										</ul>
									</div>
								</div>

								<div className='col-lg-3 col-md-6'>
									<div className='widget widget_services ftr-list-center'>
										<h3 className='widget-title'>Industries</h3>
										<ul>
											<li>
												<NavLink to={'/industries/diamonds-and-jewelry'}>
													Diamond And Jewelry
												</NavLink>
											</li>
											<li>
												<NavLink to={'/industries/precious-metals'}>
													Precious Metals
												</NavLink>
											</li>
											<li>
												<NavLink to={'/industries/bank-notes'}>
													Bank Notes
												</NavLink>
											</li>
											<li>
												<NavLink to={'/industries/fine-arts'}>
													Fine Arts
												</NavLink>
											</li>
											<li>
												<NavLink to={'/industries/electronics'}>
													Electronics
												</NavLink>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
					{/* FOOTER COPYRIGHT */}

					<div className='footer-bottom'>
						<div className='container'>
							<div className='footer-bottom-info'>
								<div className='footer-copy-right'>
									<span className='copyrights-text'>
										Copyright © 2025 by{' '}
										<span style={{ color: '#ff8a00' }}>Velocent Global</span>.
										All Rights Reserved.
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</footer>
		</>
	);
}
